import cn from 'classnames'
import type { ReactNode } from 'react'

import { CockpitCollapsedMetricValue } from '../cockpitCollapsedMetricValue'

import styles from './CockpitCollapsedMetric.module.scss'

interface ICockpitCollapsedMetricProps {
  label: ReactNode
  value: ReactNode
  valueSuffix?: ReactNode
  secondaryValue?: ReactNode
  secondarySuffix?: ReactNode
  reserveSecondarySpace?: boolean
  alignValueColumns?: boolean
  className?: string
}

export const CockpitCollapsedMetric = ({
  label,
  value,
  valueSuffix,
  secondaryValue,
  secondarySuffix,
  reserveSecondarySpace = false,
  alignValueColumns = false,
  className,
}: ICockpitCollapsedMetricProps) => {
  const showSecondary = secondaryValue !== undefined

  return (
    <div
      className={cn(styles.root, { [styles['root--alignedValues']]: alignValueColumns }, className)}
    >
      <div className={styles.label}>{label}</div>
      <div className={styles.valueRows}>
        <div className={styles.figures}>
          <CockpitCollapsedMetricValue className={styles.value}>
            {value}
          </CockpitCollapsedMetricValue>
          {valueSuffix}
        </div>
        {(showSecondary || reserveSecondarySpace) && (
          <div className={cn(styles.secondaryFigures, { [styles.hidden]: !showSecondary })}>
            <CockpitCollapsedMetricValue className={styles.secondaryValue} secondary>
              {secondaryValue}
            </CockpitCollapsedMetricValue>
            {secondarySuffix}
          </div>
        )}
      </div>
    </div>
  )
}

CockpitCollapsedMetric.displayName = 'CockpitCollapsedMetric'
